/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import fetchData from "./utils/fetchData";

const url = process.env.REACT_APP_SERVER_URL + '/tienda';

//Funcion para recuperar de la base de datos todos los productos disponibles en tienda
export const getDisponibilidad = async (comando, currentUser, dispatch, setDispTienda) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> getDisponibilidad Tienda');
    //console.log(currentUser);

    let body = {comando};
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/disponibilidad`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        setDispTienda(result.rows);
        //console.log('Respuesta backend (getDisponibilidad): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

//Funcion para recuperar de la base de datos todos los productos disponibles en tienda
export const getPreciosPan = async (comando, currentUser, dispatch, setPreciosPan) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> getPreciosPan');
    //console.log(currentUser);

    let body = {comando};
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/preciosPan`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        setPreciosPan(result.rows);
        //console.log('Respuesta backend (preciosPan): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const EnviarProductosComprados = async (datos, currentUser, dispatch) => {
    //la variable "datos" contiene: { id, codigoBarras, nombreProducto, descripcion, marcaState, categoriaState, habilitado }
    dispatch({ type: 'START_LOADING' });

    console.log('-------------->> EnviarProductosComprados');
    //console.log(currentUser);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/setCompra`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }
    
    dispatch({ type: 'END_LOADING' })

}

export const getImgVentas = async (comando, currentUser, dispatch, setImgVentas) => {
    //la variable "datos" contiene: { id, codigoBarras, nombreProducto, descripcion, marcaState, categoriaState, habilitado }
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> getImgVentas');
    //console.log(currentUser);

    let body = {comando};
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/getImgVentas`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        setImgVentas(result.rows);
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }
    
    dispatch({ type: 'END_LOADING' })

}

